import React from "react";
import "../assets/CustomerTrustGallery.css";


import image1 from '../assets/CustomerTrustGallery/samriddhi_customer1.jpeg'
import image2 from '../assets/CustomerTrustGallery/samriddhi_customer2.jpeg'
import image3 from '../assets/CustomerTrustGallery/samriddhi_customer3.jpeg'
import image4 from '../assets/CustomerTrustGallery/samriddhi_customer4.jpeg'

import image6 from '../assets/CustomerTrustGallery/samriddhi_customer6.jpeg'
import image7 from '../assets/CustomerTrustGallery/samriddhi_customer7.jpeg'
import image8 from '../assets/CustomerTrustGallery/samriddhi_customer8.jpeg'
import image9 from '../assets/CustomerTrustGallery/samriddhi_customer9.jpeg'
import image10 from '../assets/CustomerTrustGallery/samriddhi_customer10.jpeg'
import image11 from '../assets/CustomerTrustGallery/samriddhi_customer11.jpeg'
import image12 from '../assets/CustomerTrustGallery/samriddhi_customer12.jpeg'
import image13 from '../assets/CustomerTrustGallery/samriddhi_customer13.jpeg'
import image14 from '../assets/CustomerTrustGallery/samriddhi_customer14.jpeg'
import image15 from '../assets/CustomerTrustGallery/samriddhi_customer15.jpeg'
import image16 from '../assets/CustomerTrustGallery/samriddhi_customer16.jpeg'
import image17 from '../assets/CustomerTrustGallery/samriddhi_customer17.jpeg'
import image18 from '../assets/CustomerTrustGallery/samriddhi_customer18.jpeg'
import image19 from '../assets/CustomerTrustGallery/samriddhi_customer19.jpeg'


const customerImages = [

    image1,
    image2,
    image3,
    image4,

    image6,
    image7,
    image8,
    image9,
    image10,
    image11,
    image12,
    image13,
    image14,
    image15,
    image16,
    image17,
    image18,
    image19

];


const createInfiniteImages = (images) => {

    return [
        ...images,
        ...images,
    ];

};


export default function CustomerTrustGallery() {

    const rowOneImages =
        createInfiniteImages(
            customerImages.slice(0, 6)
        );


    const rowTwoImages =
        createInfiniteImages(
            customerImages.slice(4, 10)
        );


    const rowThreeImages =
        createInfiniteImages(
            customerImages.slice(6, 12)
        );


    return (

        <section className="customer-trust-container">


            {/* =================================================
                SECTION HEADER
            ================================================= */}

            <div className="customer-trust-header">

                <span className="customer-trust-label">
                    TRUSTED BY MANY
                </span>


                <h2 className="customer-trust-title">

                    Chosen with confidence.
                    <br />

                    <span>
                        Remembered with a smile.
                    </span>

                </h2>


                <p className="customer-trust-description">

                    Every agreement marks more than a transaction.
                    It marks a relationship built on trust,
                    transparency and commitment.

                </p>

                <br/>

                    <span>
                        Real Customers.

            
                    </span>

                    <span className="">Real Agreements.</span>

                    <span>
                        Real Relationships.
                    </span>


            </div>



            {/* =================================================
                CUSTOMER IMAGE WALL
            ================================================= */}

            <div className="customer-trust-wall">


                {/* =============================================
                    ROW 01
                ============================================= */}

                <div className="customer-trust-row customer-trust-row-left">

                    <div className="customer-trust-track">

                        {rowOneImages.map((image, index) => (

                            <div
                                className="customer-trust-card"
                                key={`row-one-${index}`}
                            >

                                <img
                                    src={image}
                                    alt="Samriddhi Group customer moment"
                                    loading="lazy"
                                />

                            </div>

                        ))}

                    </div>

                </div>



                {/* =============================================
                    ROW 02
                ============================================= */}

                <div className="customer-trust-row customer-trust-row-right">

                    <div className="customer-trust-track">

                        {rowTwoImages.map((image, index) => (

                            <div
                                className="customer-trust-card"
                                key={`row-two-${index}`}
                            >

                                <img
                                    src={image}
                                    alt="Samriddhi Group customer moment"
                                    loading="lazy"
                                />

                            </div>

                        ))}

                    </div>

                </div>



                {/* =============================================
                    ROW 03
                ============================================= */}

                <div className="customer-trust-row customer-trust-row-left">

                    <div className="customer-trust-track">

                        {rowThreeImages.map((image, index) => (

                            <div
                                className="customer-trust-card"
                                key={`row-three-${index}`}
                            >

                                <img
                                    src={image}
                                    alt="Samriddhi Group customer moment"
                                    loading="lazy"
                                />

                            </div>

                        ))}

                    </div>

                </div>

            </div>



            {/* =================================================
                FOOTER STATEMENT
            ================================================= */}

            <div className="customer-trust-footer">

                <span>
                    REAL CUSTOMERS
                </span>

                <div className="customer-trust-footer-line"></div>

                <span>
                    REAL RELATIONSHIPS
                </span>

            </div>


        </section>

    );

}